module.exports = __webpack_public_path__ + "img/messages_blue.808e5baf.svg";